import { Dialog } from '@angular/cdk/dialog';
import { inject, Injectable } from '@angular/core';
import { filter, of, switchMap } from 'rxjs';
import { ChatStatus } from 'src/shared/stores/chat/chat-data.store';
import { ChatWithVetDialogComponent } from 'src/shared/components/joii-chat/vet-care/chat-with-vet-dialog/chat-with-vet-dialog.component';
import { NoPaddingDialogConfig } from 'src/shared/config/dialog.config';
import { BookingDataService } from '../booking.data.service/booking.data.service';

@Injectable()
export class ChatPaymentsService {
  private bookingService = inject(BookingDataService);
  private dialog = inject(Dialog);

  getChatServicePrice(chatServiceDocId: string) {
    return this.bookingService.GetChatService(chatServiceDocId).pipe(
      switchMap((response) => {
        if (response.price) {
          return of({ price: response.price, currency: response.currency });
        } else {
          throw new Error('Chat service price not available');
        }
      })
    );
  }

  /**
   * Opens a payment dialog explaining the cost of the chat and a confirmation button to proceed with the payment.
   * @param chatServiceDocId
   */
  openPaymentDialog(chatServiceDocId: string, petName: string) {
    return of(chatServiceDocId).pipe(
      filter((docId) => !!docId),
      switchMap((docId) => this.bookingService.GetChatService(docId)),
      switchMap((d) => {
        const reference = this.dialog.open<ChatStatus | undefined>(ChatWithVetDialogComponent, {
          ...NoPaddingDialogConfig,
          data: {
            petName: petName || '',
            price: d.price,
            currency: d.currency,
          },
        });
        return reference.closed;
      })
    );
  }

  redirectToChatPayment(paymentUrl: string | undefined) {
    if (paymentUrl) {
      window.location.href = paymentUrl;
    }
  }
}
